export default "__VITE_ASSET__DMYEHGDW__"